<template>
  <div>
    <v-skeleton-loader v-if="loading" type="article, list-item-three-line@9"></v-skeleton-loader>
    <div class="px-1 pr-0">

      <!--      Buttons    -->
      <v-row class="px-2 py-1">
        <v-btn-toggle
          v-if="['FPL', 'MML', 'PAL', 'PLL', 'PPL'].includes(policy.type)
            && ['Book','dncLost','Lost','Past'].includes(policy.status)"
          v-model="doc"
          tile
          color='secondary darken-2'
          group
        >
          <v-btn class="ml-2" value="Declarations">
            Declarations
          </v-btn>
          <v-btn value="Binder">
            Binder
          </v-btn>
        </v-btn-toggle>
        <v-spacer/>
        <button-tip @click="printDiv()" color="secondary darken-2" text tile tip="Print Dialog" txt="Print" xlarge/>
      </v-row>

      <v-card class="px-4 mt-n1 mx-auto elevation-4 oldStyles rounded-0" width="985">

        <!--      Quote/Indicate Status    -->
        <div class="div2" v-if="['Quote','Indicate'].includes(policy.status)">

          <span class="my-9 quote"><!--  "quote" class -> serif font for quotes & indications headings  -->
            <br>
            <div class="my-0 h5 text-center">{{ long.carrier || '' }}</div>
            <div class="my-0 h6 text-center">{{ long.type || '' }} Proposal</div>
            <div class="my-0 h6 text-center">{{ date(policy.incept) }} - {{ date(policy.expiry) }}
              <span v-if="policy.retro">&nbsp
                ({{ moment(policy.retro, 'M-D-YYYY', true).isValid() ? 'from ' : '' }}{{ date(policy.retro) }})</span>
            </div>
            <div class="my-0 h6 text-center"><em>offered by Dominion Insurance Services to</em></div>
            <div class="my-0 h5 text-center">{{ policy.insured }}</div>
          </span>
          <br>

          <table class="caption quotetable" style="margin-left: 3px; text-align: right; width:100%">
            <colgroup v-if="policy.status === 'Indicate'"><!-- background color for estimated columns if 'Indicate' -->
              <col :span="policies.length > 1 ? 4 : 3"><!-- 'Circle One' column only needed if more than one policy -->
              <col span="6" style="background-color: whitesmoke">
            </colgroup>
            <tr v-if="policy.status === 'Indicate'"><!-- most columns are estimated for type 'Indicate' -->
              <td :colspan="policies.length > 1 ? 4 : 3"></td>
              <td colspan="6" style="background-color: whitesmoke; text-align: center">Estimated</td>
            </tr>
              <tr>
                <th style="line-height: 1.1; width: 20px !important; text-align: center" v-if="policies.length > 1">
                  Circle One</th>
                <th>Limits</th>
                <th>Deductible</th>
                <th style="width: 30px"></th><!--  helps with spacing of background color to show estimated fields -->
                <th style="width: 80px">Premium</th>
                <th>Taxes</th>
                <th>Fees</th>
                <th>Total</th>
                <th>Deposit</th>
                <th style="width: 60px" v-if="policies.length <= 1"></th>
                <th style="width: 10px"></th>
                <th style="width: 0px"></th>
              </tr>
              <tr :key="policy.pid" v-for="(policy, index) in policies">
                <td style="text-align: center" v-if="policies.length > 1">{{ index + 1 }}</td>
                <td>{{ policy.limits }}</td>
                <td>{{ $_currency(policy.deduc) }}</td>
                <td></td>
                <td>{{ $_currency(policy.premium) }}</td>
                <td>{{ $_currency(policy.taxes) }}</td>
                <td>{{ $_currency(policy.fees) }}</td>
                <td>{{ $_currency(policy.total) }}</td>
                <td>{{ $_currency(policy.down) }}</td>
                <td v-if="policies.length <= 1"></td>
                <td></td>
                <td></td>
              </tr>
          </table>
          <br>
          <div class="small_print" v-html="policy.forms.replace(/\n/g, '<br />')" v-if="policy.forms"></div>
          <div class="small_print" v-html="policy.features.replace(/\n/g, '<br />')" v-if="policy.features"></div>
          <div class="small_print" v-html="policy.docs.replace(/\n/g, '<br />')" v-if="policy.docs"></div>
          <div class="lowLeftLabel small_print">
            Applicant accepts the terms and conditions of insurance outlined above and requests binding of the same.
            Applicant authorizes Dominion Insurance Services ("Dominion") to arrange for financing of the remaining
            balance, if any, net of the payment tendered herewith, and to enter into a Premium Finance Agreement on
            Applicant's behalf. Applicant acknowledges that this insurance proposal is subject to change or withdrawal
            by the underwriter prior to binding. Applicant further acknowledges that Dominion will be compensated for
            the placement of this policy by way of commission and/or fee, or portion thereof. Unless otherwise stated,
            the above terms expire the earlier of 15 days from issuance or the first business day following the
            expiration of applicant's current policy. Binding is subject to receipt of all required documentation and
            payment. All fees and any minimum earned premium are fully earned upon binding. Further, Applicant
            acknowledges that all unreported claims and/or circumstances which might lead to a claim must be reported to
            Applicant's current and prospective carriers prior to expiration of Applicant's current policy of insurance
            and inception of the proposed coverage. Finally, Applicant warrants that there have been no substantive
            changes to its application since
            {{policy.submitted ? `it was executed on ${date(policy.submitted)}` : 'originally submitted' }},
            except for the following:
            __________________________________________________________________________________________________________________________________
            __________________________________________________________________________________________________________________________________
            <v-checkbox class="mt-n2" label="No Changes"></v-checkbox>
            <br>
            <br>
          </div>
          <div>
          Signature: _______________________________ &nbsp &nbsp &nbsp &nbsp Title: ________________
            &nbsp &nbsp &nbsp &nbsp Date: _____________
          </div>
          <br>
          <br>
          <br>
        </div>

        <!--      Other Statuses    -->
        <div class="pt-3 div2" v-else>
          <div v-if="doc !== 'Binder'" class="text-center h5 mt-2 mb-0">DECLARATIONS</div>
          <div v-if="doc === 'Binder' && ['Book','dncLost','Lost','Past'].includes(policy.status)"
               class="text-center h5 mt-2 mb-0">INSURANCE BINDER</div>
          <div v-if="doc === 'Binder' && !['Book','dncLost','Lost','Past'].includes(policy.status)"
               class="text-center h5 mt-2 mb-0">INSURANCE PROPOSAL</div>
          <div class="text-center">{{ long.type || '' }}</div>
          <div v-if="doc !== 'Binder'" class="text-center">Effected with Certain Underwriters at Lloyd's of London</div>
          <div v-if="doc !== 'Binder'" class="text-center"><b><i>Claims Made and Reported Coverage</i></b></div>
          <br>
          <v-row class="py-0 my-n5" v-if="doc === 'Binder'">
            <v-col cols="3"><b>Insurance Carrier:</b></v-col>
            <v-col cols="8">{{ policy.carrier }}</v-col>
          </v-row>
          <v-row class="py-0 my-n5" v-if="doc !== 'Binder' && policy.contract">
            <v-col cols="3"><b>Authority Number:</b></v-col>
            <v-col cols="8">{{ policy.contract }}</v-col>
          </v-row>
          <v-row class="py-0 my-n5">
            <v-col cols="3"><b>Policy Number:</b></v-col>
            <v-col cols="8">{{ policy.polnum }}</v-col>
          </v-row>
          <v-row class="py-0 my-n5">
            <v-col cols="3"><b><span v-if="doc !== 'Binder'" >1. </span>Named
              {{ doc === 'Binder' ? 'Insured' : 'Assured' }}:</b>
            </v-col>
            <v-col cols="8" class="mb-n12">
              {{ policy.insured }}
              <div class="mt-n1 mb-12">
                <span v-if="!!firm.address1">{{ firm.address1 + ', '}}</span>
                <span v-if="!!firm.address2">{{ firm.address2 + ', '}}</span>
                <span v-if="!!firm.city">{{ firm.city + ', '}}</span>
                {{ firm.state }} &nbsp{{ firm.zip }}
              </div>
            </v-col>
          </v-row>
          <v-row class="py-0 my-n5">
            <v-col cols="3"><b><span v-if="doc !== 'Binder'" >2. </span>Period of Insurance:</b></v-col>
            <v-col cols="8" v-if="policy.incept && policy.expiry">
              {{date(policy.incept)}} &nbsp to &nbsp {{date(policy.expiry)}}
              <div class="fine_print">both dates at 12:01 am
               <span v-if="doc !== 'Binder'" > at the location identified in item 1, above.</span>
              </div>
            </v-col>
            <v-col cols="8" v-if="policy.incept && !policy.expiry">{{date(policy.incept)}}
              <div class="fine_print">date is at 12:01 am
                <span v-if="doc !== 'Binder'" > at the location identified in item 1, above.</span>
              </div>
            </v-col>
            <v-col cols="8" v-if="!policy.incept">Need Date(s)</v-col>
          </v-row>
          <v-row class="py-0 my-n5">
            <v-col cols="3"><b><span v-if="doc !== 'Binder'" >3. </span>Limits of Liabilty:</b></v-col>
            <v-col cols="8">{{ policy.limits }} Per Claim/Aggregate, Including Costs and Expenses</v-col>
          </v-row>
          <v-row class="py-0 my-n5">
            <v-col cols="3"><b><span v-if="doc !== 'Binder'" >4. </span>Deductible:</b></v-col>
            <v-col cols="8">{{ policy.deduc }} Per Claim, Including Costs and Expenses</v-col>
          </v-row>
          <v-row class="py-0 my-n5">
            <v-col cols="3"><b><span v-if="doc !== 'Binder'" >5. </span>Premium:</b></v-col>
            <v-col cols="8" v-if="policy.premium">
              {{ '$' + policy.premium.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$&,') }}
            </v-col>
          </v-row>
          <v-row class="py-0 my-n5">
            <v-col cols="3"><b><span v-if="doc !== 'Binder'" >6. </span>Retroactive Date:</b></v-col>
            <v-col cols="8">{{date(policy.retro)}}</v-col>
          </v-row>
          <v-row v-if="doc !== 'Binder'" class="py-0 my-n5">
            <v-col cols="3"><b>7.	Notice of Claim:</b></v-col>
            <v-col cols="8">
              Dominion Insurance Services, Inc.<br>
              341 South Main Street, Suite 100, Alpine, Utah 84004<br>
            </v-col>
          </v-row>
          <v-row v-if="doc !== 'Binder'" class="py-0 my-n5">
            <v-col cols="3"><b>8.	Service of Suit:</b></v-col>
            <v-col cols="8">
              Wilson, Elser, Moskowitz, Edelman & Dicker LLP<br>
              150 East 42nd Street, New York, New York 10017<br>
            </v-col>
          </v-row>
          <v-row v-if="doc !== 'Binder'" class="py-0 my-n5">
            <v-col cols="3"><b>9.	Short Rate Table:</b></v-col>
            <v-col cols="8">As per attached endorsement NMA 45.</v-col>
          </v-row>
          <v-row class="py-0 my-n4">
            <v-col cols="3"><b>Prepared/Issued By:</b></v-col>
            <v-col cols="8">Dominion Insurance Services, Inc.<br>
              <v-row class="justify-start" v-if="['Book','dncLost','Lost','Past'].includes(policy.status)">
                <v-col cols="6">
                  <div class="underline">&nbsp;&nbsp;
                    <img src="https://in.dominioninsurance.com/images/Larry.gif" height="90">
                  </div>
                  &nbsp;&nbsp;Countersignature
                </v-col>
                <v-col cols="3">
                  <div class="underline"> &nbsp<img height="90" class="align-bottom"> {{date(policy.incept)}}</div>
                  &nbsp;&nbsp;Date
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <br>
          <div v-if="doc === 'Binder' && !!policy.forms" style="font-size: .94rem" class="text-start mt-2 mb-0"
               v-html="policy.forms.replace(/\n/g, '<br />')">
          </div>
          <div v-else-if="doc !== 'Binder' && links && links.length > 0">
            <v-row class="py-0 my-n6">
              <v-col cols="3"><b>Forms & Notices:</b></v-col>
              <v-col cols="8">
                <v-row v-for="link in links" :key="link.loidfid" class="my-n3">
                  <v-col>
                    <a
                       :href="`${url}/download/${link.loidfid}`">
                      <u>{{ link.file_description }}</u>
                    </a>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
          <br>
          <br>
          <br>
<!--          <div align="right" class="fine_print">Dominion MML Dec (12/15)</div>-->
        </div>
      </v-card>

      <!--   alerts    -->
      <ErrorDialog ref="errorDialog"/>
    </div>
  </div>
</template>

<script>
import ErrorDialog from "../../ErrorDialog";
import {FirmsAPIService} from "@/servicehandlers/FirmsAPIService";
import { ListsAPIService } from '../../../servicehandlers/ListsAPIService';
import moment from 'moment';
import { PoliciesAPIService } from "@/servicehandlers/PoliciesAPIService";

const firmsAPIService = new FirmsAPIService();
const listsAPIService = new ListsAPIService();
const policiesAPIService = new PoliciesAPIService();

export default {
  name: 'ViewPolicy',
  components: { ErrorDialog },
  props: {
    id: [String, Number],
    dialog: Boolean,
  },
  data: () => ({

    //--------- Data Variables ---------//

    doc: 'Binder',
    errors: [],
    firm: {},
    links: [],
    loading: false,
    long: {},
    policies: [],
    policy: {},
    url: process.env.VUE_APP_UW_URL,
  }),

  created: async function() {
    await this.getPolicy();
    this.getPolicies();
  },

  methods: {
    date(date) {// if valid 'M-D-YYYY' date return 'D MMM YYYY', else return original date or 'Full Prior Acts'
      let valid = moment(date, 'M-D-YYYY', true).isValid();
      return valid ? moment(date, 'M-D-YYYY').format('D MMM YYYY') : (date === 'FPA' ? 'Full Prior Acts' : date);
    },

    getLongs() {
      for (let field of ['carrier', 'type']) {
        let list = field === 'type' ? 'ptype' : field;
        listsAPIService.getList(list,'0',false,false, 'ASC', 'sort', true, this.$router).then((list) => {
          this.long[field] = list.find(o => o.text === this.policy[field]).long;
        });
      }
    },

    getPolicies() {// get firm policies, then filter by matching main policy to type, carrier, incept, expiry, retro
      let m = this.policy;// main policy
      firmsAPIService.getFirmPolicies(this.policy.fid, this.$router).then((policies) => {
        for (let p of policies) {// check each policy to see if it should be listed on quote/indicate under 'Circle One'
          if (p.type === m.type && p.carrier === m.carrier && p.incept === m.incept && p.expiry === m.expiry
              && p.retro === m.retro) this.policies.push(p);
          }
          this.policies.sort(function(a, b) { return a.premium - b.premium });// sort options by premium
      });
    },

    getPolicy: async function() {
      this.loading = true;
      try {
        this.policy = await policiesAPIService.getPolicy(this.id, this.$router);
        let firm = await firmsAPIService.getSingleFirm(this.policy.fid, this.$router);
        this.firm = firm;
        this.getLongs();
        if (this.policy.insured) document.title = this.policy.insured;
        this.links = await policiesAPIService.getPolicyFiles(this.policy.pid, this.$router);
        let titles = [// bold titles for forms, features, and docs
          { name: 'FORM \&amp; ENDORSEMENTS',       field: 'forms' },// this title may have slight variations
          { name: 'FORMS \&amp; ENDORSEMENTS',      field: 'forms' },
          { name: 'FORM & ENDORSEMENTS',            field: 'forms' },
          { name: 'FORMS & ENDORSEMENTS',           field: 'forms' },
          { name: 'SELECTED POLICY FEATURES',       field: 'features' },
          { name: 'QUOTE TERMS EXPIRE:',            field: 'docs' },
          { name: 'ITEMS REQUIRED TO BIND COVERAGE',field: 'docs' }]
        for (let t of titles) if (this.policy[t.field]) this.policy[t.field] = this.policy[t.field].replace(t.name, '<b>' + t.name + '</b>');
        if (this.policy.docs) this.policy.docs = this.policy.docs.replace(/�/g, "'");// replace � with ' in docs
        this.loading = false;
      } catch (e) {
        this.$refs.errorDialog.showError({
          errorMessage: "Failed to get Policy.",
          forDevelopers: e
        })
      }
    },

    printDiv(divName) {
      window.print();//
    },
  },
};
</script>

<style>
@media print
{
  body * { visibility: hidden }
  .div2 * { visibility: visible }
  .div2 { position: absolute; left: 0px; font-size: 23px; margin: -120px 0 0 !important; width: 100% !important }
  .h5 { font-size: 30px }
  .h6 { font-size: 24px }
}
@page { margin: .8in 0 .8in 1.1in !important}
.quote { font-family: Playfair, "Times New Roman", serif }
.small_print {
  font-size: 12pt;
}
.lowLeftLabel .v-input--selection-controls .v-input__slot > .v-label, .v-input--selection-controls .v-radio > .v-label {
  margin-top: 3px;
  margin-left: -4px;
}
</style>


